import React from 'react'

import './DividerWave.css'
const DividerWave = () => {
  return (
    <div className='DividerWave'>
      <div className='DividerWave__container'>
        <svg width='100%' height='100%' viewBox="0 0 1440 121" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 60V0H1439.5V120.5H738C732.477 120.5 728 116.023 728 110.5V70C728 64.4771 723.523 60 718 60H0Z"
                fill='var(--color-blue-300, #7ECDFB)'/>
        </svg>
      </div>
    </div>
  )
}

export default DividerWave
